import axios from 'axios';
import { GET_CLIENTES_USUARIO,LOGIN_USUARIO,LOGOUT_USUARIO,GET_SERVICIOS_TO_CLIENT,GET_TAREAS_TO_SERVICIO,
  START_LOADING_SERVICIOS, FINISH_LOADING_SERVICIOS,DATO_USUARIO,GET_TODOS_CLIENTES,
  START_LOADING_CLIENTES,FINISH_LOADING_CLIENTES,LOGIN_ERROR,CLEAR_HORAS,GET_TODAS_AREAS,OBTENER_ESTADO_HORAS_HABILITADAS,
  START_LOADING_TAREAS,LIMPIAR_HORAS,OBTENER_HORAS,SET_USUARIOS,SET_HORAS_REPORTE,HABILITAR_HORAS,
  FINISH_LOADING_TAREAS,LIMPIAR_SERVICIOS,LIMPIAR_TAREAS,ACTUALIZAR_ESTADO_TARJETAS,
   CARGAR_HORAS, CARGAR_HORAS_EXITO, CARGAR_HORAS_ERROR, ACTUALIZAR_HORAS,CARGAR_HORAS_USUARIO,ACTUALIZAR_HORAS_USUARIO_LOGIN,ELIMINAR_HORAS,GET_SERVICIOS_TO_AREA_CLIENT,
   // Nuevos action types para mis horas
   GET_MIS_HORAS_MES_ACTUAL, GET_MIS_HORAS_POR_CLIENTE, GET_MIS_HORAS_POR_SEMANA, 
   GET_MIS_HORAS_POR_FECHA, GET_MIS_HORAS_RESUMEN, LOADING_MIS_HORAS, ERROR_MIS_HORAS,
   // Nuevos action types para reporte de usuario
   GET_HORAS_REPORTE_USUARIO, GET_HORAS_REPORTE_TODOS_USUARIOS, LOADING_REPORTE_USUARIO, 
   ERROR_REPORTE_USUARIO, CLEAR_REPORTE_USUARIO,
   // Nuevos action types para reporte de clientes
   GET_HORAS_REPORTE_CLIENTE, GET_HORAS_REPORTE_TODOS_CLIENTES, LOADING_REPORTE_CLIENTE,
   ERROR_REPORTE_CLIENTE, CLEAR_REPORTE_CLIENTE,
   // Nuevos action types para reporte de área
   GET_HORAS_REPORTE_AREA, LOADING_REPORTE_AREA, ERROR_REPORTE_AREA, CLEAR_REPORTE_AREA} from './actionstypes.js';

import axiosClient from './.././axiosClient.js';
import { logger } from '../utils/logger.js';

// Definir la acción

// esta acción se encarga de limpiar las horas en los estados de la aplicación 
// no se esta usando por el momento 
const limpiarHoras = () => {
  return {
    type: LIMPIAR_HORAS
  };
};

// Esta es una función de acción de Redux Thunk que se utiliza para obtener todas las tareas
//y tener actualizados las tareas en las card ya cargadas.
const getTodasTareas = () => {
  return async (dispatch) => {
       // Se despacha una acción para indicar que se ha iniciado la carga de las tareas.
    dispatch({ type: START_LOADING_TAREAS });

    try {
    // Se obtiene el token del usuario logueado en el sistema para realizar la petición.
      const token = localStorage.getItem('token');
      // Se realiza la petición GET a la API para obtener todas las tareas.
      const response = await axiosClient.get('/tareas/tareas', {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
    /// Se despacha una acción para almacenar las tareas obtenidas en el estado de la aplicación.
      dispatch({
        type: 'GET_TODAS_TAREAS',
        payload: response.data
      });
    } catch (error) {
      console.error(error);
    } finally {
      dispatch({ type: FINISH_LOADING_TAREAS });
    }
  };
};

// Esta es una función de acción de Redux Thunk que se utiliza para obtener todas las áreas.
// se usa para cargar las areas para el reporte de horas por area
const getTodasAreas = () => {
  return async (dispatch) => {
    try {
      console.log('Cargando todas las áreas...');
      const token = localStorage.getItem('token');
      const response = await axiosClient.get('/horas/areas', {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      logger.log('Respuesta de áreas del servidor:', response.data);

      dispatch({
        type: GET_TODAS_AREAS,
        payload: response.data
      });
      
      return response.data;
    } catch (error) {
      console.error('Error al cargar áreas:', error);
      throw error;
    }
  };
};

const createCliente = (datosCliente) => {
  return async function(dispatch) {
    try {
      const { nombre, descripcion, correo, numeroContacto, direccion, estado, areas } = datosCliente;
      logger.log('Creando cliente con datos:', datosCliente);
      const token = localStorage.getItem('token');
      
      const response = await axiosClient.post("/clientes/cliente", {
       nombre,
  correo: correo || '', // Campo opcional con valor por defecto
  numeroContacto: numeroContacto || '', // Campo opcional
  direccion: direccion || '', // Campo opcional
  estado: estado, // Boolean: true/false
  areas: areas, // IDs de áreas

      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      logger.log('Respuesta del servidor al crear cliente:', response.data);
      
      if (response.data.cliente) {
        return { success: true, data: response.data };
      } else {
        return { success: false, error: 'No se pudo crear el cliente' };
      }
    } catch (error) {
      logger.error('Error al crear cliente:', error);
      return { 
        success: false, 
        error: error.response?.data?.mensaje || 'Error al crear el cliente'
      };
    }
  };
};
const updateCliente = (id, nombre, correo, numeroContacto, direccion, estado, areaIds, servicioIds) => {
  return async function(dispatch) {
    try {
      logger.log('Actualizando cliente:', { id, nombre, areaIds, servicioIds });
      const token = localStorage.getItem('token');
      const response = await axiosClient.put(`/clientes/cliente/${id}`, {
        nombre,
        correo,
        numeroContacto, 
        direccion,
        estado,
        areaIds,
        servicioIds
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      console.log('Respuesta del servidor al actualizar cliente:', response.data);
      
      // Actualizar la lista de clientes en el estado
      dispatch(getTodosClientes());
        
      return response.data.cliente;
      
    } catch (error) {
      console.error('Error al actualizar cliente:', error);
      throw error; // Re-lanzar el error para manejarlo en el componente
    }
  };
};

// Esta es una función de acción de Redux Thunk que se utiliza para obtener todos los clientes del usuario.
// se usa para cargar los clientes que correspondas con el usuario logueado segun sus areas
const getClientesUsuario = () => {
  return async function(dispatch) {
    dispatch({ type: START_LOADING_CLIENTES });
    const token = localStorage.getItem('token');
    try {
      var json = await axiosClient.get("/clientes/cliente/usuario", {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
    //  console.log(json.data);
      return dispatch({
        type: GET_CLIENTES_USUARIO,
        payload: json.data
      });
    } catch (error) {
      console.error(error);
    } finally {
      dispatch({ type: FINISH_LOADING_CLIENTES });
    }
  };
};

// Esta es una función de acción de Redux Thunk que se utiliza para obtener 
//los clientes para los reportes de clientes
const getTodosClientes = () => {
  return async (dispatch) => {
    dispatch({ type: START_LOADING_CLIENTES });

    try {
      const token = localStorage.getItem('token');
      const response = await axiosClient.get('/clientes/cliente', {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      console.log('Clientes recibidos del backend:', response.data);
      console.log('Primer cliente como ejemplo:', response.data[0]);

      dispatch({
        type: GET_TODOS_CLIENTES,
        payload: response.data
      });

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      dispatch({ type: FINISH_LOADING_CLIENTES });
    }
  };
};

// Función para obtener un cliente específico por ID con todos sus datos
const getClientePorId = (clienteId) => {
  return async function(dispatch) {
    try {
      const token = localStorage.getItem('token');
      logger.log('🔍 Obteniendo cliente completo por ID:', clienteId);
      
      // Usar el endpoint de admin que incluye áreas y servicios
      const response = await axiosClient.get(`/clientes/cliente/admin`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      logger.log('🔍 Respuesta completa de clientes admin:', response.data);
      
      // Filtrar el cliente específico
      const clienteCompleto = response.data.find(c => c.id === parseInt(clienteId));
      
      if (!clienteCompleto) {
        throw new Error(`Cliente con ID ${clienteId} no encontrado`);
      }
      
      logger.log('✅ Cliente completo encontrado:', clienteCompleto);
      return clienteCompleto;
    } catch (error) {
      logger.error('❌ Error al obtener cliente por ID:', clienteId, error);
      throw error;
    }
  };
};

// Función para agregar servicios a un cliente
const addServicioACliente = (clienteId, serviciosIds) => {
  return async function(dispatch) {
    try {
      const token = localStorage.getItem('token');
      const response = await axiosClient.post(`/clientes/clientes/${clienteId}/servicios`, {
        serviciosIds
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      // Actualizar la lista de clientes para reflejar los nuevos servicios
      dispatch(getTodosClientes());

      return response.data;
    } catch (error) {
      console.error('Error al agregar servicios al cliente:', error);
      throw error; // Re-lanzar el error para manejarlo en el componente
    }
  };
};

// Esta es una función de acción de Redux Thunk que se utiliza para obtener los servicios de un cliente.
// se usa para cargar los servicios que corresponden a un cliente en la picklist de servicios
const getServicios = (clienteId) => {
  return async (dispatch) => {
    dispatch({ type: START_LOADING_SERVICIOS });

    try {
      const token = localStorage.getItem('token');
      const response = await axiosClient.get(`/servicios/servicios/cliente/${clienteId}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
   //  console.log(response.data);
      dispatch({
        type: GET_SERVICIOS_TO_CLIENT,
        payload: response.data
      });
    } catch (error) {
      console.error(error);
    } finally {
      dispatch({ type: FINISH_LOADING_SERVICIOS });
    }
  };
};

const getServiciosPorAreaCliente = (clienteId, areaIds = null) => {
  return async (dispatch) => {
    dispatch({ type: START_LOADING_SERVICIOS });
    try {
      const token = localStorage.getItem('token');
      
      // Usar la misma estructura que las rutas que funcionan
      logger.log('Solicitando servicios para cliente:', clienteId);
      
      const response = await axiosClient.get(`/servicios/servicios/areas/cliente/${clienteId}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      console.log('Servicios recibidos del servidor:', response.data);

      dispatch({
        type: GET_SERVICIOS_TO_AREA_CLIENT,
        payload: response.data || [] // Asegurar que siempre sea un array
      });
      
      return response.data;
    } catch (error) {
      logger.error('Error al cargar servicios para cliente:', clienteId, 'áreas:', areaIds, error);
      // En caso de error, dispatch un array vacío para evitar undefined
      dispatch({
        type: GET_SERVICIOS_TO_AREA_CLIENT,
        payload: []
      });
      throw error;
    } finally {
      dispatch({ type: FINISH_LOADING_SERVICIOS });
    }
  };
};

// Nueva función para obtener servicios por nombres de áreas específicas
const getServiciosPorAreas = (areaIds, areasArray) => {
  return async (dispatch) => {
    dispatch({ type: START_LOADING_SERVICIOS });
    try {
      const token = localStorage.getItem('token');
      
      // Convertir IDs a nombres de áreas
      const nombresAreas = areaIds.map(id => {
        const area = areasArray.find(a => a.id === id);
        return area ? area.nombre : null;
      }).filter(nombre => nombre !== null);
      
      logger.log('Solicitando servicios para áreas:', nombresAreas);
      
      // Crear query string con los nombres de áreas
      const areasQuery = nombresAreas.join(',');
      const url = `/servicios/areas?areas=${encodeURIComponent(areasQuery)}`;
      
      console.log('🔍 URL completa que se va a llamar:', `http://localhost:4000${url}`);
      console.log('🔑 Token:', token ? 'Presente' : 'Ausente');
      
      const response = await axiosClient.get(url, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      console.log('✅ Servicios por áreas recibidos:', response.data);

      dispatch({
        type: GET_SERVICIOS_TO_AREA_CLIENT,
        payload: response.data || []
      });
      
      return response.data;
    } catch (error) {
      console.error('❌ Error completo:', error);
      console.error('❌ Error response:', error.response?.data);
      console.error('❌ Error status:', error.response?.status);
      logger.error('Error al cargar servicios por áreas:', areaIds, error);
      dispatch({
        type: GET_SERVICIOS_TO_AREA_CLIENT,
        payload: []
      });
      throw error;
    } finally {
      dispatch({ type: FINISH_LOADING_SERVICIOS });
    }
  };
};

// Acción para asignar servicios a un cliente
const asignarServiciosACliente = (clienteId, servicioIds) => {
  return async function(dispatch) {
    try {
      const token = localStorage.getItem('token');
      
      const response = await axiosClient.put(`/clientes/cliente/${clienteId}/servicios`, {
        servicioIds: servicioIds
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      logger.log('Servicios asignados al cliente exitosamente:', response.data);
      return { success: true, data: response.data };
    } catch (error) {
      logger.error('Error al asignar servicios al cliente:', error);
      return { 
        success: false, 
        error: error.response?.data?.mensaje || 'Error al asignar servicios al cliente'
      };
    }
  };
};

// Esta es una función de acción de Redux Thunk que se utiliza para obtener las tareas de un servicio.
//se usa para cargar las tareas que corresponden a un servicio en la picklist de tareas
const getTareas = (servicioId) => {
  return async (dispatch) => {
    dispatch({ type: START_LOADING_TAREAS });
    try {
      const token = localStorage.getItem('token');
      const response = await axiosClient.get(`/tareas/tareas/servicio/${servicioId}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      dispatch({
        type: GET_TAREAS_TO_SERVICIO,
        payload: response.data
      });
    } catch (error) {
      console.error(error);
    } finally {
      dispatch({ type: FINISH_LOADING_TAREAS });
    }
  };
};

// Esta es una función de acción de Redux Thunk que se utiliza para iniciar sesión en la aplicación.
//y tambien para obtener los datos del cliente logueado
const loginUsuario = (email, password) => {
  return async function(dispatch) {
    try {
      const response = await axiosClient.post("/usuarios/login", {
        email,
        contrasena: password
      });
    //  console.log(response.data);

      const token = response.data.token;
      localStorage.setItem('token', token);
      // Método de login: lo usa "Mi Perfil" para saber si pedir o no la contraseña actual.
      localStorage.setItem('loginMethod', 'password');

      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const response2 = await axiosClient.get("/usuarios/usuarios/me", {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
 //     console.log('Datos del usuario:', response2.data);

      dispatch({
        type: LOGIN_USUARIO,
        payload: {
          token: token,
          id: response.data.id,
          perfil: response.data.perfil
        }
      });
      dispatch({
        type: DATO_USUARIO,
        payload: {
          usuario: response2.data // Cambia esto
        }
      });

      const horas = JSON.parse(localStorage.getItem(`horas-${response.data.id}`));
      if (horas) {
        dispatch({
          type: CARGAR_HORAS_USUARIO,
          payload: horas
        });
      }
      // Estas 4 peticiones son independientes entre sí: se lanzan en paralelo
      // para que el login termine más rápido (antes iban una tras otra).
      await Promise.all([
        dispatch(obtenerEstadoHorasHabilitadas()),
        dispatch(getTareasDefault()),
        dispatch(getClientesUsuario()),
        dispatch(getTodasTareas())
      ]);
      //window.location.reload();
    } catch (error) {
      console.error(error);
      let errorMessage = 'Ocurrió un error al intentar iniciar sesión';
      if (error.response && error.response.status === 401) {
        errorMessage = 'Usuario o contraseña incorrectos';
      }
      dispatch({
        type: LOGIN_ERROR,
        payload: errorMessage
      });
    }
  };
};

// Acción para iniciar sesión con Google.
// Recibe el "credential" (ID token) que devuelve el botón de Google, lo manda al backend,
// y si el email existe en la base, hace exactamente el mismo flujo que el login normal.
const loginConGoogle = (credential) => {
  return async function(dispatch) {
    try {
      const response = await axiosClient.post("/usuarios/google-login", { credential });

      const token = response.data.token;
      localStorage.setItem('token', token);
      // Método de login: lo usa "Mi Perfil" para saber si pedir o no la contraseña actual.
      localStorage.setItem('loginMethod', 'google');

      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const response2 = await axiosClient.get("/usuarios/usuarios/me", {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      dispatch({
        type: LOGIN_USUARIO,
        payload: {
          token: token,
          id: response.data.id,
          perfil: response.data.perfil
        }
      });
      dispatch({
        type: DATO_USUARIO,
        payload: {
          usuario: response2.data
        }
      });

      const horas = JSON.parse(localStorage.getItem(`horas-${response.data.id}`));
      if (horas) {
        dispatch({
          type: CARGAR_HORAS_USUARIO,
          payload: horas
        });
      }
      // Igual que en el login normal: las 4 peticiones van en paralelo.
      await Promise.all([
        dispatch(obtenerEstadoHorasHabilitadas()),
        dispatch(getTareasDefault()),
        dispatch(getClientesUsuario()),
        dispatch(getTodasTareas())
      ]);
    } catch (error) {
      console.error(error);
      let errorMessage = 'No se pudo iniciar sesión con Google';
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        errorMessage = (error.response.data && error.response.data.mensaje)
          ? error.response.data.mensaje
          : 'Tu cuenta de Google no está habilitada en el sistema';
      }
      dispatch({
        type: LOGIN_ERROR,
        payload: errorMessage
      });
    }
  };
};

// Esta es una función de acción de Redux Thunk que se utiliza para cerrar la sesión del usuario.
const logoutUsuario = () => {
  return function(dispatch, getState){
    return new Promise((resolve, reject) => {
      try {
        const usuarioId = getState().session.id;

        // Eliminar los registros de las horas del usuario del localStorage
        localStorage.removeItem(`horas-${usuarioId}`);

        // Limpiar otros datos de sesión
        localStorage.removeItem('token');

        // Limpiar también la semana actual
        localStorage.removeItem('semanaActual');

        // Limpiar el método de login guardado para "Mi Perfil"
        localStorage.removeItem('loginMethod');

        dispatch({ type: LOGOUT_USUARIO });
        dispatch({ type: LIMPIAR_SERVICIOS }); // acción para limpiar los servicios
        dispatch({ type: LIMPIAR_TAREAS }); // acción para limpiar las tareas
        dispatch({ type: LIMPIAR_HORAS }); // acción para resetear el estado de las horas
       
       //window.location.reload();

        resolve();
      } catch (error) {
        reject(error);
      }
    });
  };
};

// Cambiar la propia contraseña del usuario logueado (sección "Mi Perfil").
// Devuelve { ok: true } o { ok: false, mensaje } para que el componente muestre el feedback.
const cambiarMiContrasena = (contrasenaActual, nuevaContrasena) => {
  return async function() {
    try {
      const token = localStorage.getItem('token');
      const { data } = await axiosClient.patch(
        '/usuarios/usuarios/me/password',
        { contrasenaActual, nuevaContrasena },
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      // A partir de ahora siempre se exige la contraseña actual.
      localStorage.setItem('loginMethod', 'password');
      return { ok: true, mensaje: data.mensaje };
    } catch (error) {
      const mensaje = error.response && error.response.data && error.response.data.mensaje
        ? error.response.data.mensaje
        : 'No se pudo cambiar la contraseña';
      return { ok: false, mensaje };
    }
  };
};

// Esta es una función de acción de Redux Thunk que se utiliza para cargar las horas de un usuario en el formulario.
const cargarHoras = (datos) => (dispatch, getState) => {
  return new Promise(async (resolve, reject) => {
    dispatch({ type: CARGAR_HORAS });

    try {
      const { session } = getState();
      const token = localStorage.getItem('token');
      const response = await axiosClient.post('/horas/cargarhoras', {
        ...datos,
        senorityhora: session.perfil,
        usuarioId: session.id,
        fechaCarga: datos.fechaCarga,
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
    
      dispatch({ type: CARGAR_HORAS_EXITO, payload: { ...response.data, cardId: datos.cardId } });// se despacha la acción para cargar las horas
      dispatch(obtenerEstadoHorasHabilitadas());// se obtiene el estado de las horas habilitadas
      dispatch(obtenerHoras());// se obtienen las horas del usuario para actualizar el estaado de las card y mostrar losdatos en las card ya cargdas
      dispatch(actualizarTodosEstadosTarjetas());// se actualizan los estados de las tarjetas
      resolve(response);// se resuelve la promesa
    } catch (error) {
      dispatch({ type: CARGAR_HORAS_ERROR, payload: error.message });
      reject(error);
    }
  });
};

// Esta es una función de acción de Redux Thunk que se utiliza para actualizar las horas de un usuario
// Es decir, cuando se le da al boton de editar y luego se actualizan las horas
const actualizarHoras = (datosFormulario) => {
  return async function(dispatch){
    try {
      const token = localStorage.getItem('token');
  
      const response = await axiosClient.put(`/horas/actualizarhoras/${datosFormulario.id}`, datosFormulario, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
  
      dispatch({
        type: ACTUALIZAR_HORAS,
        payload: response.data
      });
      dispatch(obtenerEstadoHorasHabilitadas());// se obtiene el estado de las horas habilitadas
      dispatch(obtenerHoras());// se obtienen las horas del usuario para actualizar el estaado de las card y mostrar losdatos en las card ya cargdas
    //  window.location.reload();
  
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };
};

// Esta es una función de acción de Redux Thunk que se utiliza para obtener las horas de un usuario.
// es para saber las horas que ha cargado el usuario y esa sean las que se muestren segun el usuario logueado
const obtenerHoras = () => {
  return async function(dispatch, getState) {
    try {
      const usuario = getState().session;
      const token = localStorage.getItem('token');
      if (!usuario) {
        throw new Error('El usuario no ha iniciado sesión');
      }
    
      const idUsuario = usuario.id;
      // Ya no enviamos horasHabilitadas, el backend lo verificará desde la BD
      const response = await axiosClient.get(`/horas/horasusuario/${idUsuario}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
  
      if (Array.isArray(response.data.horasUsuario)) {
        // Logging detallado para diagnóstico del problema de meses
        console.log('=== DIAGNÓSTICO HORAS OBTENIDAS ===');
        console.log('Total de horas recibidas:', response.data.horasUsuario.length);
        console.log('Usuario ID:', idUsuario);
        
        // Agrupar horas por mes para verificar qué meses se están trayendo
        const horasPorMes = {};
        response.data.horasUsuario.forEach(hora => {
          if (hora.fechaCarga) {
            const [dia, mes, ano] = hora.fechaCarga.split('/');
            const mesClave = `${mes}/${ano}`;
            if (!horasPorMes[mesClave]) {
              horasPorMes[mesClave] = [];
            }
            horasPorMes[mesClave].push(hora);
          }
        });
        
        console.log('Horas agrupadas por mes:', horasPorMes);
        console.log('Meses con datos:', Object.keys(horasPorMes));
        console.log('Cantidad de horas por mes:', Object.entries(horasPorMes).map(([mes, horas]) => ({ mes, cantidad: horas.length })));
        console.log('=== FIN DIAGNÓSTICO ===');
        
        dispatch({
          type: OBTENER_HORAS,
          payload: response.data.horasUsuario
        });

        console.log('Todas las horas cargadas:', response.data.horasUsuario);
      } else {
        console.log('hora o hora.fechaCarga es undefined o no es una fecha válida');
      }
    } catch (error) {
      console.error(error);
    }
  };
};

// Esta es una función de acción de Redux Thunk que se utiliza para actulizar el estado de las horas del usuario logueado
// se usa para sabaer si se esta actualizando una hora o si se esta cargando una hora nueva(el estado horas que se usaen el formulario)
   const actualizarHorasUsuariologin = (fecha, nuevasHoras) => ({
    type: ACTUALIZAR_HORAS_USUARIO_LOGIN,
    payload: { fecha, nuevasHoras }
  });
 // Función resetearHoras eliminada - no se utiliza

  // Esta es una función de acción de Redux Thunk que se utiliza para recargar la sesión del usuario.
  // se usa para recargar la sesion del usuario y obtener los datos del usuario logueado al momento de inicar sesion
  const rehydrateSession = (token) => {
    return async function(dispatch, getState){
      try {
        // Configurar el token de autenticación globalmente
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    
        // Obtener la información del usuario a partir del token
        const response = await axiosClient.get("/usuarios/usuarios/me", {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
    
        dispatch({
          type: LOGIN_USUARIO,
          payload: {
            token: token,
            id: response.data.id,
            perfil: response.data.perfil
          }
        });
    
        // Cargar los registros del usuario que está iniciando sesión
        dispatch(obtenerEstadoHorasHabilitadas());
        dispatch(obtenerHoras());
        
         
    
        // Imprimir los datos del usuario y los registros de las tarjetas
     //   console.log('Datos del usuario:', response.data);
        //console.log('Registros de las tarjetas:', getState().horas);
         // RESET_STATE dispatch eliminado - no se utiliza
      } catch (error) {
        console.error(error);
      }
    };
  };
  
  // Esta accion se utiliza para eliminar las horas de un usuario
  const eliminarHoras = (id) => {
    return async function(dispatch){
      try {
        const token = localStorage.getItem('token');
    
        const response = await axiosClient.delete(`/horas/eliminarhoras/${id}`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
    
        dispatch({ type: ELIMINAR_HORAS, payload: id });// se despacha la acción para eliminar las horas
        dispatch(obtenerHoras());// se obtienen las horas del usuario para actualizar el estaado de las card y mostrar losdatos en las card ya cargdas
       // window.location.reload();
        return response.data;
      } catch (error) {
        console.error(error);
      }
    };
  };
  
  // Esta acción se utiliza para obtener las tareas por defecto en la piclist cuando no se selicione un servicio
  const getTareasDefault = () => {
    return async (dispatch) => {
      try {
        const token = localStorage.getItem('token');
        const response = await axiosClient.get('/tareas/especificas', {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
  
        dispatch({
          type: 'GET_TAREAS_DEFAULT',
          payload: response.data
        });
      } catch (error) {
        console.error(error);
      }
    };
    
  };

  //es para setear el estados de las tareas por defecto no se esta usando todavia
   const setTareas = (tareas) => {
    return {
      type: 'SET_TAREAS_DEFAULT',
      payload: tareas
    };
  };

// Esta acción se utiliza para actualizar el estado de las tarjetas si hay algun cambioen los componentes
  const actualizarTodosEstadosTarjetas = (nuevosEstados) => {
    return {
      type: ACTUALIZAR_ESTADO_TARJETAS,
      payload: nuevosEstados
    };
  };

// Esta acción se utiliza para llenar el estado de usuarios
// para la piclist de usaurios para los reportes
  const fetchUsuarios = () => {
    return async (dispatch) => {
   
      try {
        const token = localStorage.getItem('token');
        const response = await axiosClient.get('/usuarios/usuarios', {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
  
        dispatch({
          type: SET_USUARIOS,
          payload: response.data
        });
      } catch (error) {
        console.error(error);
      } 
    };
  };
  
  // Esta acción se utiliza para obtener las horas de un usuario en un rango de fechas
  const fetchHoras = (usuarioSeleccionado, fechaDesde, fechaHasta) => {
    return async (dispatch) => {
      try {
        const token = localStorage.getItem('token');
        const response = await axiosClient.get(`/horas/horasusuario/${usuarioSeleccionado}/rango`, {
          params: {
            fechaDesde,
            fechaHasta
          },
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
  
  
        dispatch({
          type: SET_HORAS_REPORTE,
          payload: response.data
        });
      }catch (error) {
        console.error(error);
        if (error.response) {
          if (error.response.status === 403) {
            const customError = new Error(error.response.data.mensaje);
            customError.response = error.response;
            throw customError;
          } else if (error.response.status === 404) {
            const customError = new Error(error.response.data.mensaje);
            customError.response = error.response;
            throw customError;
          }
        }
        throw error;
      }
    };
  };

  // Esta acción se utiliza para obtener todas las horas de todos los usuarios en un rango de fechas  
  const fetchTodasHoras = (fechaDesde, fechaHasta) => {
    return async (dispatch) => {
      try {
        const token = localStorage.getItem('token');
        const response = await axiosClient.get(`/horas/horastodosusuarios/rango`, {
          params: {
            fechaDesde,
            fechaHasta
          },
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
  
        dispatch({
          type: SET_HORAS_REPORTE,
          payload: response.data
        });
      } catch (error) {
        console.error(error);
        if (error.response) {
          if (error.response.status === 403) {
            const customError = new Error(error.response.data.mensaje);
            customError.response = error.response;
            throw customError;
          } else if (error.response.status === 404) {
            const customError = new Error(error.response.data.mensaje);
            customError.response = error.response;
            throw customError;
          }
        }
        throw error;
      }
    };
  };

  // Esta acción se utiliza para obtener las horas de un cliente en un rango de fechas
  const fetchHorasCliente = (clienteSeleccionado, fechaDesde, fechaHasta) => {
    return async (dispatch) => {
      try {
        const token = localStorage.getItem('token');
        const response = await axiosClient.get(`/horas/horascliente/${clienteSeleccionado}/rango`, {
          params: {
            fechaDesde,
            fechaHasta
          },
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
  console.log(response.data);
        dispatch({
          type: SET_HORAS_REPORTE,
          payload: response.data
        });
      }catch (error) {
        console.error(error);
        if (error.response) {
          if (error.response.status === 403) {
            const customError = new Error(error.response.data.mensaje);
            customError.response = error.response;
            throw customError;
          } else if (error.response.status === 404) {
            const customError = new Error(error.response.data.mensaje);
            customError.response = error.response;
            throw customError;
          }
        }
        throw error;
      }
    };
  };

  // Esta acción se utiliza para obtener las horas de un área en un rango de fechas
  const fetchHorasArea = (areaSeleccionada, fechaDesde, fechaHasta) => {
    return async (dispatch) => {
      try {
        const token = localStorage.getItem('token');
        const response = await axiosClient.get(`/horas/horasarea/${areaSeleccionada}/rango`, {
          params: {
            fechaDesde,
            fechaHasta
          },
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
  
        console.log(response.data);
  
        dispatch({
          type: SET_HORAS_REPORTE,
          payload: response.data
        });
      } catch (error) {
        console.error(error);
        if (error.response) {
          if (error.response.status === 403) {
            const customError = new Error(error.response.data.mensaje);
            customError.response = error.response;
            throw customError;
          } else if (error.response.status === 404) {
            const customError = new Error(error.response.data.mensaje);
            customError.response = error.response;
            throw customError;
          }
        }
        throw error;
      }
    };
  };

  // Esta acción se utiliza para habilitar o deshabilitar la carga o edicion de horas
  // Ahora acepta un array de IDs de usuarios para habilitar selectivamente
  const habilitarHoras = (usuarioIds = []) => {
    return async function(dispatch){
      try {
        const token = localStorage.getItem('token');
  
        const response = await axiosClient.put('/horas/actualizarhorashabilitadas', { 
          habilitada: usuarioIds.length > 0,
          usuarioIds: usuarioIds
        }, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
  
        dispatch({
          type: HABILITAR_HORAS,
          payload: {
            habilitada: response.data.habilitada || (usuarioIds.length > 0),
            usuarioIds: usuarioIds
          }
        });
        dispatch(obtenerEstadoHorasHabilitadas());
  
        return response.data;
      } catch (error) {
        console.error(error);
      }
    };
  };

  // Esta acción se utiliza para obtener el estado de las horas habilitadas y llenar el estado
  // y saber si estan habilitados o desabilitados, ahora tambien trae los usuarios habilitados
  const obtenerEstadoHorasHabilitadas = () => {
    return async function(dispatch){
      try {
        const token = localStorage.getItem('token');
  
        const response = await axiosClient.get('/horas/horashabilitadas', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
  
        dispatch({
          type: OBTENER_ESTADO_HORAS_HABILITADAS,
          payload: {
            habilitada: response.data.habilitada,
            usuarioIds: response.data.usuarioIds || []
          }
        });
  
        return response.data;
      } catch (error) {
        console.error(error);
      }
    };
  };

// Esta acción se utiliza para limpiar las horas, no se usa por el momento
 const clearHoras = () => {
    return {
      type: CLEAR_HORAS
    };
  };

// Esta acción se utiliza para limpiar los servicios
//se usa para limpiar el estado de la piclist de servicos para cuando se cierra el modal, para cargar registro
   const limpiarServicios = () => {
    return {
      type: LIMPIAR_SERVICIOS
    };
  };

// ========== ACTIONS PARA MIS HORAS DEL USUARIO LOGUEADO ==========

// Action para obtener las horas del mes actual del usuario logueado
const obtenerMisHorasMesActual = () => {
  return async function(dispatch) {
    dispatch({ type: LOADING_MIS_HORAS });
    
    try {
      const token = localStorage.getItem('token');
      const response = await axiosClient.get('/horas/mis-horas/mes-actual', {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      dispatch({
        type: GET_MIS_HORAS_MES_ACTUAL,
        payload: response.data
      });

      return response.data;
    } catch (error) {
      console.error('Error al obtener mis horas del mes actual:', error);
      dispatch({
        type: ERROR_MIS_HORAS,
        payload: error.response?.data?.mensaje || 'Error al cargar las horas'
      });
      throw error;
    }
  };
};

// Action para obtener las horas del usuario filtradas por cliente y mes
const obtenerMisHorasPorClienteMes = (clienteId, mes = null, año = null) => {
  return async function(dispatch) {
    dispatch({ type: LOADING_MIS_HORAS });
    
    try {
      const token = localStorage.getItem('token');
      let url = `/horas/mis-horas/por-cliente?clienteId=${clienteId}`;
      
      // Solo agregar mes y año si ambos están presentes y no son null/undefined
      if (mes && año && mes.toString().trim() !== '' && año.toString().trim() !== '') {
        url += `&mes=${mes}&año=${año}`;
      }

      console.log('🔍 URL para obtener horas por cliente:', url);

      const response = await axiosClient.get(url, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      console.log('✅ Respuesta del servidor para horas por cliente:', response.data);

      dispatch({
        type: GET_MIS_HORAS_POR_CLIENTE,
        payload: response.data
      });

      return response.data;
    } catch (error) {
      console.error('Error al obtener mis horas por cliente:', error);
      dispatch({
        type: ERROR_MIS_HORAS,
        payload: error.response?.data?.mensaje || 'Error al cargar las horas por cliente'
      });
      throw error;
    }
  };
};

// Action para obtener las horas del usuario de una semana específica
const obtenerMisHorasPorSemana = (fechaInicio, fechaFin) => {
  return async function(dispatch) {
    dispatch({ type: LOADING_MIS_HORAS });
    
    try {
      const token = localStorage.getItem('token');
      const response = await axiosClient.get(`/horas/mis-horas/por-semana?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      dispatch({
        type: GET_MIS_HORAS_POR_SEMANA,
        payload: response.data
      });

      return response.data;
    } catch (error) {
      console.error('Error al obtener mis horas por semana:', error);
      dispatch({
        type: ERROR_MIS_HORAS,
        payload: error.response?.data?.mensaje || 'Error al cargar las horas de la semana'
      });
      throw error;
    }
  };
};

// Action para obtener las horas del usuario de una fecha específica
const obtenerMisHorasPorFecha = (fecha) => {
  return async function(dispatch) {
    dispatch({ type: LOADING_MIS_HORAS });
    
    try {
      const token = localStorage.getItem('token');
      const response = await axiosClient.get(`/horas/mis-horas/por-fecha?fecha=${fecha}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      dispatch({
        type: GET_MIS_HORAS_POR_FECHA,
        payload: response.data
      });

      return response.data;
    } catch (error) {
      console.error('Error al obtener mis horas por fecha:', error);
      dispatch({
        type: ERROR_MIS_HORAS,
        payload: error.response?.data?.mensaje || 'Error al cargar las horas de la fecha'
      });
      throw error;
    }
  };
};

// Action para obtener resumen de horas con filtros avanzados
const obtenerMisHorasResumen = (filtros = {}) => {
  return async function(dispatch) {
    dispatch({ type: LOADING_MIS_HORAS });
    
    try {
      const token = localStorage.getItem('token');
      
      // Construir query string con los filtros
      const params = new URLSearchParams();
      if (filtros.fechaDesde) params.append('fechaDesde', filtros.fechaDesde);
      if (filtros.fechaHasta) params.append('fechaHasta', filtros.fechaHasta);
      if (filtros.clienteId) params.append('clienteId', filtros.clienteId);
      if (filtros.servicioId) params.append('servicioId', filtros.servicioId);
      if (filtros.tareaId) params.append('tareaId', filtros.tareaId);
      
      const queryString = params.toString();
      const url = `/horas/mis-horas/resumen${queryString ? `?${queryString}` : ''}`;

      const response = await axiosClient.get(url, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      dispatch({
        type: GET_MIS_HORAS_RESUMEN,
        payload: response.data
      });

      return response.data;
    } catch (error) {
      console.error('Error al obtener resumen de mis horas:', error);
      dispatch({
        type: ERROR_MIS_HORAS,
        payload: error.response?.data?.mensaje || 'Error al cargar el resumen de horas'
      });
      throw error;
    }
  };
};

// ========== ACTIONS PARA COMBINAR CLIENTE CON OTROS FILTROS ==========

// Action para obtener las horas de un cliente en una fecha específica
const obtenerMisHorasClientePorFecha = (clienteId, fecha) => {
  return async function(dispatch) {
    dispatch({ type: LOADING_MIS_HORAS });
    
    try {
      const token = localStorage.getItem('token');
      const response = await axiosClient.get(`/horas/mis-horas/por-fecha?fecha=${fecha}&clienteId=${clienteId}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      dispatch({
        type: GET_MIS_HORAS_POR_FECHA,
        payload: response.data
      });

      return response.data;
    } catch (error) {
      console.error('Error al obtener mis horas de cliente por fecha:', error);
      dispatch({
        type: ERROR_MIS_HORAS,
        payload: error.response?.data?.mensaje || 'Error al cargar las horas de la fecha'
      });
      throw error;
    }
  };
};

// Action para obtener las horas de un cliente en un rango de semana
const obtenerMisHorasClientePorSemana = (clienteId, fechaInicio, fechaFin) => {
  return async function(dispatch) {
    dispatch({ type: LOADING_MIS_HORAS });
    
    try {
      const token = localStorage.getItem('token');
      const response = await axiosClient.get(`/horas/mis-horas/por-semana?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}&clienteId=${clienteId}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      dispatch({
        type: GET_MIS_HORAS_POR_SEMANA,
        payload: response.data
      });

      return response.data;
    } catch (error) {
      console.error('Error al obtener mis horas de cliente por semana:', error);
      dispatch({
        type: ERROR_MIS_HORAS,
        payload: error.response?.data?.mensaje || 'Error al cargar las horas de la semana'
      });
      throw error;
    }
  };
};

// ========== ACCIONES PARA REPORTE DE USUARIO ==========

// Acción para obtener horas de un usuario específico para reportes
const obtenerHorasReporteUsuario = (usuarioId, fechaInicio, fechaFin) => {
  return async (dispatch) => {
    dispatch({ type: LOADING_REPORTE_USUARIO });
    
    try {
      console.log('📅 Enviando petición para usuario:', usuarioId, 'fechas:', fechaInicio, 'a', fechaFin);
      
      const token = localStorage.getItem('token');
      const response = await axiosClient.get(`/horas/horasusuario/${usuarioId}/rango`, {
        params: {
          fechaDesde: fechaInicio,
          fechaHasta: fechaFin
        },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      console.log('✅ Respuesta del servidor para usuario específico:', response.data);

      dispatch({
        type: GET_HORAS_REPORTE_USUARIO,
        payload: response.data
      });

      return response.data;
    } catch (error) {
      console.error('❌ Error al obtener horas del usuario:', error);
      const errorMessage = error.response?.data?.mensaje || 'Error al obtener las horas del usuario';
      
      dispatch({
        type: ERROR_REPORTE_USUARIO,
        payload: errorMessage
      });
      
      throw new Error(errorMessage);
    }
  };
};

// Acción para obtener horas de todos los usuarios para reportes
const obtenerHorasReporteTodosUsuarios = (fechaInicio, fechaFin) => {
  return async (dispatch) => {
    dispatch({ type: LOADING_REPORTE_USUARIO });
    
    try {
      console.log('📅 Enviando petición para todos los usuarios, fechas:', fechaInicio, 'a', fechaFin);
      
      const token = localStorage.getItem('token');
      const response = await axiosClient.get('/horas/horastodosusuarios/rango', {
        params: {
          fechaDesde: fechaInicio,
          fechaHasta: fechaFin
        },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      console.log('✅ Respuesta del servidor para todos los usuarios:', response.data);

      dispatch({
        type: GET_HORAS_REPORTE_TODOS_USUARIOS,
        payload: response.data
      });

      return response.data;
    } catch (error) {
      console.error('❌ Error al obtener horas de todos los usuarios:', error);
      const errorMessage = error.response?.data?.mensaje || 'Error al obtener las horas de todos los usuarios';
      
      dispatch({
        type: ERROR_REPORTE_USUARIO,
        payload: errorMessage
      });
      
      throw new Error(errorMessage);
    }
  };
};

// Acción para obtener horas de un usuario específico con filtro de cliente para reportes
const obtenerHorasReporteUsuarioConCliente = (userId, fechaInicio, fechaFin, clienteId = null) => {
  return async (dispatch) => {
    dispatch({ type: LOADING_REPORTE_USUARIO });
    
    try {
      console.log('📅 Enviando petición con filtro de cliente:', { userId, fechaInicio, fechaFin, clienteId });
      
      const token = localStorage.getItem('token');
      let url = `/horas/horasusuario/${userId}/rango-cliente`;
      let params = {
        fechaDesde: fechaInicio,
        fechaHasta: fechaFin
      };

      // Si hay clienteId, agregarlo a los parámetros
      if (clienteId && clienteId !== '') {
        params.clienteId = clienteId;
      }

      const response = await axiosClient.get(url, {
        params,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      console.log('✅ Respuesta del servidor usuario con cliente:', response.data);

      dispatch({
        type: GET_HORAS_REPORTE_USUARIO,
        payload: response.data
      });

      return response.data;
    } catch (error) {
      console.error('❌ Error al obtener horas del usuario con cliente:', error);
      const errorMessage = error.response?.data?.mensaje || 'Error al obtener las horas del usuario';
      
      dispatch({
        type: ERROR_REPORTE_USUARIO,
        payload: errorMessage
      });
      
      throw new Error(errorMessage);
    }
  };
};

// Acción para obtener horas de todos los usuarios con filtro de cliente para reportes
const obtenerHorasReporteTodosUsuariosConCliente = (fechaInicio, fechaFin, clienteId = null) => {
  return async (dispatch) => {
    dispatch({ type: LOADING_REPORTE_USUARIO });
    
    try {
      console.log('📅 Enviando petición todos los usuarios con filtro de cliente:', { fechaInicio, fechaFin, clienteId });
      
      const token = localStorage.getItem('token');
      let params = {
        fechaDesde: fechaInicio,
        fechaHasta: fechaFin
      };

      // Si hay clienteId, agregarlo a los parámetros
      if (clienteId && clienteId !== '') {
        params.clienteId = clienteId;
      }

      const response = await axiosClient.get('/horas/horastodosusuarios/rango-cliente', {
        params,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      console.log('✅ Respuesta del servidor todos los usuarios con cliente:', response.data);

      dispatch({
        type: GET_HORAS_REPORTE_TODOS_USUARIOS,
        payload: response.data
      });

      return response.data;
    } catch (error) {
      console.error('❌ Error al obtener horas de todos los usuarios con cliente:', error);
      const errorMessage = error.response?.data?.mensaje || 'Error al obtener las horas de todos los usuarios';
      
      dispatch({
        type: ERROR_REPORTE_USUARIO,
        payload: errorMessage
      });
      
      throw new Error(errorMessage);
    }
  };
};

// Acción para limpiar el estado del reporte de usuario
const limpiarReporteUsuario = () => ({
  type: CLEAR_REPORTE_USUARIO
});

// ========== ACCIONES PARA REPORTE DE CLIENTES ==========

// Acción para obtener horas de un cliente específico para reportes
const obtenerHorasReporteCliente = (clienteId, fechaInicio, fechaFin) => {
  return async (dispatch) => {
    dispatch({ type: LOADING_REPORTE_CLIENTE });
    
    try {
      console.log('📊 Enviando petición para cliente:', clienteId, 'fechas:', fechaInicio, 'a', fechaFin);
      
      const token = localStorage.getItem('token');
      const response = await axiosClient.get(`/horas/horascliente/${clienteId}/rango`, {
        params: {
          fechaDesde: fechaInicio,
          fechaHasta: fechaFin
        },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      console.log('✅ Respuesta del servidor para cliente específico:', response.data);

      dispatch({
        type: GET_HORAS_REPORTE_CLIENTE,
        payload: response.data
      });

      return response.data;
    } catch (error) {
      console.error('❌ Error al obtener horas del cliente:', error);
      const errorMessage = error.response?.data?.mensaje || 'Error al obtener las horas del cliente';
      
      dispatch({
        type: ERROR_REPORTE_CLIENTE,
        payload: errorMessage
      });
      
      throw new Error(errorMessage);
    }
  };
};

// Acción para obtener horas de todos los clientes para reportes
const obtenerHorasReporteTodosClientes = (fechaInicio, fechaFin) => {
  return async (dispatch) => {
    dispatch({ type: LOADING_REPORTE_CLIENTE });
    
    try {
      console.log('📊 Enviando petición para todos los clientes, fechas:', fechaInicio, 'a', fechaFin);
      
      const token = localStorage.getItem('token');
      const response = await axiosClient.get('/horas/horastodosusuarios/rango', {
        params: {
          fechaDesde: fechaInicio,
          fechaHasta: fechaFin
        },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      console.log('✅ Respuesta del servidor para todos los clientes:', response.data);

      dispatch({
        type: GET_HORAS_REPORTE_TODOS_CLIENTES,
        payload: response.data
      });

      return response.data;
    } catch (error) {
      console.error('❌ Error al obtener horas de todos los clientes:', error);
      const errorMessage = error.response?.data?.mensaje || 'Error al obtener las horas de todos los clientes';
      
      dispatch({
        type: ERROR_REPORTE_CLIENTE,
        payload: errorMessage
      });
      
      throw new Error(errorMessage);
    }
  };
};

// Acción para limpiar el estado del reporte de clientes
const limpiarReporteCliente = () => ({
  type: CLEAR_REPORTE_CLIENTE
});

// ========== ACCIONES PARA REPORTE DE ÁREA ==========

// Acción para obtener horas por área para reportes
const obtenerHorasReporteArea = ({ fechaInicio, fechaFin, areaId, usuarioId }) => {
  return async (dispatch) => {
    dispatch({ type: LOADING_REPORTE_AREA });
    
    try {
      console.log('📊 Enviando petición para reporte de área:', { fechaInicio, fechaFin, areaId, usuarioId });
      
      const token = localStorage.getItem('token');
      let url = '/horas/horastodosusuarios/rango';
      
      // Construir parámetros de la consulta
      const params = {
        fechaDesde: fechaInicio,
        fechaHasta: fechaFin
      };
      
      if (areaId) {
        params.areaId = areaId;
      }
      
      if (usuarioId) {
        params.usuarioId = usuarioId;
      }
      
      const response = await axiosClient.get(url, {
        params,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      console.log('✅ Respuesta del servidor para reporte de área:', response.data);

      dispatch({
        type: GET_HORAS_REPORTE_AREA,
        payload: response.data
      });

      return response.data;
    } catch (error) {
      console.error('❌ Error al obtener horas por área:', error);
      const errorMessage = error.response?.data?.mensaje || 'Error al obtener las horas por área';
      
      dispatch({
        type: ERROR_REPORTE_AREA,
        payload: errorMessage
      });
      
      throw new Error(errorMessage);
    }
  };
};

// Acción para limpiar el estado del reporte de área
const limpiarReporteArea = () => ({
  type: CLEAR_REPORTE_AREA
});

  
// Exportar la acción
export { 
  // Acciones principales
  fetchUsuarios,
  limpiarServicios,
  habilitarHoras,
  getTodosClientes,
  getTodasAreas,
  fetchHorasArea,
  fetchTodasHoras,
  fetchHorasCliente,
  fetchHoras,
  clearHoras,
  getClientesUsuario,
  actualizarTodosEstadosTarjetas,
  loginUsuario,
  loginConGoogle,
  limpiarHoras,
  logoutUsuario,
  cambiarMiContrasena,
  getServicios,
  getTareas,
  cargarHoras,
  actualizarHoras,
  obtenerHoras,
  actualizarHorasUsuariologin,
  rehydrateSession,
  eliminarHoras,
  getTareasDefault,
  setTareas,
  getTodasTareas,
  getServiciosPorAreaCliente,
  addServicioACliente,
  updateCliente,
  createCliente,
  asignarServiciosACliente,
  getServiciosPorAreas,
  getClientePorId,
  obtenerEstadoHorasHabilitadas,
  // Nuevas actions para mis horas
  obtenerMisHorasMesActual,
  obtenerMisHorasPorClienteMes,
  obtenerMisHorasPorSemana,
  obtenerMisHorasPorFecha,
  obtenerMisHorasResumen,
  // Actions para combinar cliente con otros filtros
  obtenerMisHorasClientePorFecha,
  obtenerMisHorasClientePorSemana,
  // Nuevas actions para reporte de usuario
  obtenerHorasReporteUsuario,
  obtenerHorasReporteTodosUsuarios,
  limpiarReporteUsuario,
  // Nuevas actions para reporte de usuario con filtro de cliente
  obtenerHorasReporteUsuarioConCliente,
  obtenerHorasReporteTodosUsuariosConCliente,
  // Nuevas actions para reporte de clientes
  obtenerHorasReporteCliente,
  obtenerHorasReporteTodosClientes,
  limpiarReporteCliente,
  // Nuevas actions para reporte de área
  obtenerHorasReporteArea,
  limpiarReporteArea,
  // Nuevas actions para gestión de usuarios
  getTodosUsuarios,
  crearUsuario,
  actualizarUsuario,
  eliminarUsuario,
  resetearContrasenaUsuario
};
// ============================================
// ACCIONES PARA GESTIÓN DE USUARIOS
// ============================================

// Obtener todos los usuarios
const getTodosUsuarios = () => {
  return async function(dispatch) {
    try {
      const token = localStorage.getItem('token');
      
      const response = await axiosClient.get('/usuarios/usuarios', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      logger.log('Usuarios obtenidos exitosamente:', response.data);
      
      // Disparar la acción para actualizar el estado Redux
      dispatch({
        type: SET_USUARIOS,
        payload: response.data
      });
      
      return { success: true, data: response.data };
    } catch (error) {
      logger.error('Error al obtener usuarios:', error);
      return { 
        success: false, 
        error: error.response?.data?.mensaje || 'Error al obtener usuarios'
      };
    }
  };
};

// Crear nuevo usuario
const crearUsuario = (datosUsuario) => {
  return async function(dispatch) {
    try {
      const token = localStorage.getItem('token');
      
      const response = await axiosClient.post('/usuarios/usuarios', datosUsuario, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      logger.log('Usuario creado exitosamente:', response.data);
      return { success: true, data: response.data };
    } catch (error) {
      logger.error('Error al crear usuario:', error);
      return { 
        success: false, 
        error: error.response?.data?.mensaje || 'Error al crear usuario'
      };
    }
  };
};

// Actualizar usuario
const actualizarUsuario = (usuarioId, datosUsuario) => {
  return async function(dispatch) {
    try {
      const token = localStorage.getItem('token');
      
      const response = await axiosClient.put(`/usuarios/usuarios/${usuarioId}`, datosUsuario, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      logger.log('Usuario actualizado exitosamente:', response.data);
      return { success: true, data: response.data };
    } catch (error) {
      logger.error('Error al actualizar usuario:', error);
      return { 
        success: false, 
        error: error.response?.data?.mensaje || 'Error al actualizar usuario'
      };
    }
  };
};

// Eliminar usuario
const eliminarUsuario = (usuarioId) => {
  return async function(dispatch) {
    try {
      const token = localStorage.getItem('token');
      
      const response = await axiosClient.delete(`/usuarios/usuarios/${usuarioId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      logger.log('Usuario eliminado exitosamente:', response.data);
      return { success: true, data: response.data };
    } catch (error) {
      logger.error('Error al eliminar usuario:', error);
      return { 
        success: false, 
        error: error.response?.data?.mensaje || 'Error al eliminar usuario'
      };
    }
  };
};

// Resetear contraseña de usuario
const resetearContrasenaUsuario = (usuarioId, nuevaContrasena) => {
  return async function(dispatch) {
    try {
      const token = localStorage.getItem('token');
      
      const response = await axiosClient.patch(`/usuarios/usuarios/${usuarioId}/reset-password`, {
        nuevaContrasena: nuevaContrasena
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      logger.log('Contraseña reseteada exitosamente:', response.data);
      return { success: true, data: response.data };
    } catch (error) {
      logger.error('Error al resetear contraseña:', error);
      return { 
        success: false, 
        error: error.response?.data?.mensaje || 'Error al resetear contraseña'
      };
    }
  };
};


